import { render, staticRenderFns } from "./WaypointsList.vue?vue&type=template&id=3b144b40&scoped=true"
import script from "./WaypointsList.vue?vue&type=script&lang=js"
export * from "./WaypointsList.vue?vue&type=script&lang=js"
import style0 from "./WaypointsList.vue?vue&type=style&index=0&id=3b144b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b144b40",
  null
  
)

export default component.exports